var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardWidgetArea',{attrs:{"widget":_vm.widget},scopedSlots:_vm._u([{key:"right-side",fn:function(){return [_vm._t("right-side")]},proxy:true},{key:"content",fn:function(){return [_c('LineChart',{staticClass:"dashboard-widget-chart__chart",attrs:{"chart-data":_vm.chartData,"options":_vm.options}})]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }